import { render, staticRenderFns } from "./ProCard4.vue?vue&type=template&id=8e1f8018&scoped=true"
import script from "./ProCard4.vue?vue&type=script&lang=js"
export * from "./ProCard4.vue?vue&type=script&lang=js"
import style0 from "./ProCard4.vue?vue&type=style&index=0&id=8e1f8018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1f8018",
  null
  
)

export default component.exports